import React from "react";
import "./Lead.css";

// Pending Images Upload

function Lead(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="socialmedia.png" alt="Logo"/>
          Landing Page Creation & Optimization</h5>
          <p className="card-text"><br/>We design high-converting landing pages tailored to capture user interest and turn visitors into potential leads. Every element—from the headline to the call-to-action—is strategically placed to drive inquiries and conversions.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="searchengine.png" alt="Logo"/>
             Paid Advertising Campaigns (Google & Social Media)</h5>
          <p className="card-text"><br/>
          We run highly targeted ads on platforms like Google, Facebook, and Instagram to reach your ideal audience. Our ad strategies are crafted to bring in quality leads while keeping cost-per-lead low and performance high.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="Google.png" alt="Logo"/>
          Lead Magnets & Offers</h5>
          <p className="card-text"><br/><br/>We create valuable resources like eBooks, discount codes, free trials, and downloadable guides to attract potential customers. These lead magnets are designed to encourage users to share their contact info in exchange for value.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="content.png" alt="Logo"/>
            CRM Integration & Automation</h5>
          <p className="card-text">We set up smart CRM systems and automation tools to collect, organize, and follow up with leads efficiently. Whether it’s email drip campaigns or WhatsApp follow-ups, we ensure no lead is lost in the process.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="email.png" alt="Logo"/>
          Analytics & Lead Quality Reports</h5>
          <p className="card-text">We create valuable and SEO-optimized content such as blogs, articles, landing pages, and social media captions that educate, inform, and convert. Our content marketing builds trust and positions your brand as a leader in your niche.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Lead;